export function SuggestedPrompts({
  prompts,
  disabled,
  onSelect,
}: {
  prompts: string[];
  disabled: boolean;
  onSelect: (prompt: string) => void;
}) {
  if (!prompts.length) {
    return null;
  }

  return (
    <div className="cbm-prompts">
      {prompts.map((prompt) => (
        <button
          key={prompt}
          type="button"
          className="cbm-chip"
          disabled={disabled}
          onClick={() => onSelect(prompt)}
        >
          {prompt}
        </button>
      ))}
    </div>
  );
}
